import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { Region } from '@/models/region';
import { RegionService } from '@/services/region-service';

const regionService = new RegionService();

export const state = {
  regions: [] as Region[]
};

export type RegionState = typeof state;

export const mutations: MutationTree<RegionState> = {
  SET_REGIONS(state: any, payload: Region[]) {
    state.regions = payload;
  },

  ADD_REGION(state: any, payload: Region) {
    state.regions.push(payload);
  },

  UPDATE_REGION(state: any, payload: Region) {
    const index = state.regions.findIndex(
      (region: Region) => region.id === payload.id
    );
    state.regions.splice(index, 1, payload);
  },

  REMOVE_REGION(state: any, payload: number) {
    const index = state.regions.findIndex(
      (region: Region) => region.id === payload
    );
    state.regions.splice(index, 1);
  }
};

export const actions: ActionTree<RegionState, RegionState> = {
  createRegion: async ({ commit }: any, payload: Region) =>
    regionService
      .createRegion(payload)
      .then((region: Region) => commit('ADD_REGION', region)),

  fetchRegions: async ({ commit }: any) =>
    regionService.fetchRegions().then((regions: Region[]) => {
      commit('SET_REGIONS', regions);
    }),

  fetchRegion: async ({ commit }: any, payload: number) =>
    regionService.fetchRegion(payload).then((region: Region) => {
      const index = state.regions.findIndex((v: Region) => v.id === region.id);
      if (index === -1) {
        commit('ADD_REGION', region);
      } else {
        commit('UPDATE_REGION', region);
      }
    }),

  updateRegion: async ({ state, commit }: any, payload: Region) =>
    regionService.updateRegion(payload).then((region: Region) => {
      const index = state.regions.findIndex((v: Region) => v.id === region.id);
      if (index === -1) {
        commit('ADD_REGION', region);
      } else {
        commit('UPDATE_REGION', region);
      }
    }),

  deleteRegion: async ({ commit }: any, payload: number) =>
    regionService.deleteRegion(payload).then(() => {
      commit('REMOVE_REGION', payload);
    })
};

export const getters: GetterTree<RegionState, RegionState> = {
  getRegionById: (state: RegionState) => (id: number) => {
    return state.regions.find(region => region.id === id);
  }
};
